import { setErrorDialog, serverUrl, getheader, postMethodByCallBack, getMethodByCallBack, cacheTypes } from "../../../store/api/CommonFunctions";
export function getStageTypes() {
    return dispatch => {
        dispatch({
            type: "STAGE_TYPES",
            data: "PENDING"
        });
        fetch(serverUrl + "api/WorkFlowAPI/GetStageTypes", {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                dispatch({
                    type: "STAGE_TYPES",
                    data: res
                });
            }).catch(e => console.log("[STAGE_TYPES]", e));
    }
}
export function addOrUpdateStage(data, onAddEdit) {
    postMethodByCallBack("api/WorkFlowAPI/AddOrUpdateStage", data, onAddEdit, "AddOrUpdateStage");
}
export function getStageList(entityType, fn) {
    return dispatch => {
        dispatch({
            type: "FLOW_STAGE_LIST",
            data: "PENDING"
        });
        fetch(serverUrl + "api/WorkFlowAPI/GetStageList?entityType=" + entityType, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "دریافت فهرست مراحل");
                    res = null;
                }
                if (fn) {
                    fn(res);
                }
                dispatch({
                    type: "FLOW_STAGE_LIST",
                    data: res
                });
            }).catch(e => console.log("[FLOW_STAGE_LIST]", e));
    }
}
export function getEntityStatusList(entityType, fn) {
    fetch(serverUrl + "api/WorkFlowAPI/GetEntityStatusList?entityType=" + entityType, {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = [];
            }
            fn(res);
        }).catch(e => console.log("[GetEntityStatusList]", e));
}
export function getStageStatusList(entityType, stageID, fn) {
    fetch(serverUrl + `api/WorkFlowAPI/GetStageStatusList?entityType=${entityType}&stageID=${stageID}`, {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = [];
            }
            fn(res);
        }).catch(e => console.log("[GetStageStatusList]", e));
}
export function getStageAuthorizedStatusList(stageID, onGet) {
    getMethodByCallBack(`api/WorkFlowAPI/GetStageAuthorizedStatusList?stageID=${stageID}`, cacheTypes.NoCache, onGet, "GetStageAuthorizedStatusList");
}


export function setStatusStage(data, fn) {
    return dispatch => {
        fetch(serverUrl + "api/WorkFlowAPI/SetStatusStage", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (!res.Message) {
                    setErrorDialog(dispatch, "success", "ثبت وضعیت");
                    fn(res);
                }
                else {
                    setErrorDialog(dispatch, res.Message, "ثبت وضعیت");
                }
            }).catch(e => console.log("[SetStatusStage]", e));
    }
}
export function deleteStage(id, fn) {
    return dispatch => {
        fetch(serverUrl + "api/WorkFlowAPI/DeleteStage", {
            headers: getheader(),
            body: id,
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "حذف مرحله کاری");
                    return;
                }
                setErrorDialog(dispatch, "success", "حذف مرحله کاری");
                if (fn) {
                    fn(id);
                }
            }).catch(e => console.log("[DeleteStage]", e));
    }
}
export function getStage(id, onGet) {
    getMethodByCallBack(`/api/WorkFlowAPI/GetStage?id=${id}`, cacheTypes.NoCache, onGet, "GetStage");
}
export function getUserList(name, onGet) {
    if (!name) {
        name = "";
    }
    getMethodByCallBack(`api/UserAPI/SearchUser?Name=${name}`, cacheTypes.NoCache, onGet, "SearchUser");
}
export function getStageUserAndStatusList(userName, stageID, onGet) {
    getMethodByCallBack(`api/WorkFlowAPI/GetStageUserAndStatusList?userName=${userName}&stageID=${stageID}`, cacheTypes.NoCache, onGet, "GetStageUserAndStatusList");
}
export function getDefaultDescList(onGet){
    getMethodByCallBack(`api/UserDashboardAPI/GetDefaultDescList`,cacheTypes.NoCache, onGet, "GetDefaultDescList");
}